// React + Vite entry. Mirrors apps/dashboard/src/main.tsx; differences:
//   • afterSignOutUrl points at admin's sign-in page.
//   • No font weight 400 import (admin SPA uses 500/600/700 only — the
//     UI is dense and 400 reads thin in dark mode against L0 surfaces).

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { env } from './env.js';
import { AppRouter } from './routes/router.js';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('root element missing from index.html');

createRoot(container).render(
  <StrictMode>
    <ClerkProvider publishableKey={env.clerkPublishableKey} afterSignOutUrl="/sign-in">
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppRouter />
      </BrowserRouter>
    </ClerkProvider>
  </StrictMode>,
);
